import { translations } from '../../../utils/staticContent';
import './style.scss';

function About() {
    return (
        <div className="About">
            <h1>{translations.aboutUs}</h1>
            <p>
                Zavod Neodvisni obalni radio je ljudski medija v lokalnem prostoru severne Istre.
                Zasnovan je kot neprofiten, študentski in skupnostni radio. Nastal je kot
                entuziastičen projekt in neodvisno od kapitalskih interesov. Namen radia NOR je
                ustvarjati neodvisen medijski prostor, ki spodbuja kritično razmišljanje, kulturno
                raznolikost ter aktivno udeležbo lokalnih skupnosti. NOR deluje kot platforma za
                povezovanje različnih skupnosti, izobraževanje, ustvarjalnost in aktivno
                družbeno-politično držo.
            </p>
            <div className="columns">
                <div className="column column-1">
                    <section>
                        <p>Zavod Neodvisni obalni radio</p>
                        <p>Nazorjev trg 5</p>
                        <p>6000 Koper - Capodistria</p>
                        <p>Dv. št.: 55247652</p>
                        <p>Matična št.: 8270414000</p>
                        <p>TRR: SI56 6100 0001 9909 209 DH d.d.</p>
                    </section>
                    <section>
                        <p className="section-title">Svet zavoda</p>
                        <p>Član 1</p>
                        <p>Član 2</p>
                        <p>Član 3</p>
                    </section>
                    <section>
                        <p className="section-title">Direktor</p>
                        <p>Toni Bračanov</p>
                        <a href="mailto:toni.bracanov@noradio.org" target="_blank" rel="noreferrer">
                            toni.bracanov@noradio.org
                        </a>
                    </section>
                    <section>
                        <p className="section-title">v.d. odgovorni urednik</p>
                        <p>Arne Zupančič</p>
                    </section>
                </div>
                <div className="column column-2">
                    <section>
                        <p className="section-title">Kontakti</p>
                        <a href="mailto:info@noradio.org" target="_blank" rel="noreferrer">
                            info@noradio.org
                        </a>
                        <a
                            href="mailto:glasbena.redakcija@noradio.org"
                            target="_blank"
                            rel="noreferrer"
                        >
                            glasbena.redakcija@noradio.org
                        </a>
                    </section>
                </div>
                <div className="column column-3">
                    <section>
                        <p className="section-title">Poročila</p>
                    </section>
                </div>
            </div>
        </div>
    );
}

export default About;
